<template>
  <div class="fill-height">
    <v-content class="fill-height">
      <v-container fluid>
        <Loader v-if="loading"/>
        <template v-else>
          <template v-if="count">
            <v-card rounded>
              <PageBar :title="`${title} «${$route.query.key}»`" :back="true"/>
              <Results :list="list"/>
            </v-card>
          </template>
          <EmptyList v-else/>
        </template>
      </v-container>
    </v-content>
  </div>
</template>

<script>
export default {
  name: 'Actual',
  components: {
    Loader:    ()  => import('@/components/placeholder/Loader'),
    Results:   ()  => import('@/components/list/Search'),
    PageBar:   ()  => import('@/components/bar/Page.vue'),
    EmptyList: ()  => import('@/components/placeholder/EmptyList'),
  },
  data: () => ({
    title: "Результаты поиска по запросу",
    loading: true,
    list: [],
    offset: 0,
    count: 0
  }),
  watch: {
    '$route.query.key': function () {
      this.getSearchList();
    },
    '$route.query.target': function () {
      this.getSearchList();
    }
  },
  methods: {
    getSearchList() {
      this.loading = true;
      let url;
      console.log(this.$route.query.target)
      if (!this.$route.query.target) {
        url = `${this.$serverApiLink}ticket/search`;
      } else {
        url = `${this.$serverApiLink}ticket/target`
      }
      this.$http.post(url, {
        "message": !this.$route.query.target ? this.$route.query.key : this.$route.query.key * 1,
      }).then(
          response => {
            if (!this.$route.query.target) {
              this.list = response.data.data.list;
              this.count = response.data.data.count;
            } else {
              if (response.data.data) {
                this.$router.replace({ name: 'ticket', params: { id: response.data.data } })
              } else {
                this.list = [];
                this.count = 0;
              }
            }
            this.loading = false;
          }
      ).catch(
          error => {
            this.$store.commit('setSnack', {
              status: true,
              code: error.response.status,
              message: error.response.data.message,
              type: 'error'
            });
            window.console.log(error.response)
            this.loading = false;
          }
      );
    }
  },
  mounted() {
    this.getSearchList();
  }
}
</script>